import { render, staticRenderFns } from "./ModalEditRecipient.vue?vue&type=template&id=551fc7eb&scoped=true"
import script from "./ModalEditRecipient.vue?vue&type=script&lang=js"
export * from "./ModalEditRecipient.vue?vue&type=script&lang=js"
import style0 from "./ModalEditRecipient.vue?vue&type=style&index=0&id=551fc7eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551fc7eb",
  null
  
)

export default component.exports